import { WidgetContext } from 'Pages/Widget/Widget.constants';
import { useContext, useMemo } from 'react';
import { selectAppointmentByAppointmentId } from 'store/appointment/selectors';
import { selectIndustryByIndustryId } from '../store/industry/selectors';
import { useAppSelector } from './hooks';

export const useGetSelectedIndustry = () => {
  const { state } = useContext(WidgetContext);
  const { selectedIndustryId } = state;
  const industry = useAppSelector((state) => selectIndustryByIndustryId(state, selectedIndustryId));
  return industry;
};

export const useGetSelectedAppointment = () => {
  const { state } = useContext(WidgetContext);
  const { selectedAppointmentId } = state;
  const appointment = useAppSelector((state) => selectAppointmentByAppointmentId(state, selectedAppointmentId));
  return appointment;
};

export const useGetSelectedAddons = () => {
  const { state } = useContext(WidgetContext);
  const { selectedAppointmentId, selectedAddonIds } = state;
  const appointment = useAppSelector((state) => selectAppointmentByAppointmentId(state, selectedAppointmentId));

  return useMemo(() => {
    if (!appointment) {
      return [];
    }
    const { addons } = appointment;
    return addons.filter((addon) => selectedAddonIds.includes(addon.id));
  }, [appointment, selectedAddonIds]);
};

export const useGetSelectedVariant = () => {
  const { state } = useContext(WidgetContext);
  const { selectedAppointmentId, selectedVariantId } = state;
  const appointment = useAppSelector((state) => selectAppointmentByAppointmentId(state, selectedAppointmentId));

  return useMemo(() => {
    if (!appointment) {
      return undefined;
    }
    const { variants } = appointment;
    return variants.find((variant) => variant.id === selectedVariantId);
  }, [appointment, selectedVariantId]);
};
